import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon, StarIcon } from "lucide-react";
import { offer } from "../data/salesCopy";
import { usePlan } from "../contexts/PlanContext";
import { CtaButton } from "./CtaButton";
const trustIcons = [LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon];
export function PricingCards() {
  const {
    selectedId,
    setSelectedId
  } = usePlan();
  const selected = offer.plans.find(p => p.id === selectedId) ?? offer.plans[0];
  return <div className="mx-auto max-w-3xl" data-id="element-223" data-mp="2fdcky0am2hxp">
      <div role="radiogroup" aria-label="Elegí tu opción" className="grid grid-cols-2 items-stretch gap-2.5 pt-3 md:gap-4" data-id="element-224" data-mp="2k5m2ot1kobow">
        {offer.plans.map(p => {
        const isOn = p.id === selectedId;
        return <button key={p.id} type="button" role="radio" aria-checked={isOn} onClick={() => setSelectedId(p.id)} className={`relative flex flex-col rounded-2xl p-3 text-left transition-[background-color,box-shadow,transform] duration-150 ease-out active:scale-[0.98] md:p-5 ${isOn ? p.featured ? "bg-pencil-soft ring-[3px] ring-pencil" : "bg-card ring-[3px] ring-chalk" : p.featured ? "bg-card ring-2 ring-pencil/60" : "bg-card ring-1 ring-line"}`} data-id="element-225" data-mp="2u4l4brnx772e">
              {p.featured && <span className="absolute -top-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-pencil px-2.5 py-1 text-[10px] font-extrabold text-ink md:text-xs" data-id="element-226" data-mp="b3ghbu0obezs">
                  <StarIcon className="h-3 w-3 fill-ink" aria-hidden="true" data-id="element-227" data-mp="2acyf679e9xr" />
                  {p.badge}
                </span>}

              <span className="flex items-start justify-between gap-2" data-id="element-228" data-mp="u213d7npju6k">
                <span className={`text-[11px] font-extrabold tracking-wide md:text-sm ${p.featured ? "mt-1 text-ink" : "text-muted"}`} data-id="element-229" data-mp="tzy745vyp4te">{p.name}</span>
                <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors duration-150 ease-out ${isOn ? p.featured ? "border-chalk bg-chalk text-white" : "border-chalk bg-chalk text-white" : "border-line bg-card"} ${p.featured ? "mt-1" : ""}`} aria-hidden="true" data-id="element-230" data-mp="2t7of38xfgq85">
                  {isOn && <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-231" data-mp="2ajt4tz10xujs" />}
                </span>
              </span>

              <span className="mt-1 text-[11px] leading-snug text-muted md:text-sm" data-id="element-232" data-mp="1vmsbxs73jtjq">{p.includes}</span>

              <span className="mt-auto pt-2" data-id="element-233" data-mp="20m4zkf5sl4nd">
                <span className="block text-xs text-muted line-through md:text-sm" data-id="element-234" data-mp="3pyqn3zoyuzi9">{p.oldPrice}</span>
                <span className={`block font-display font-extrabold leading-none ${p.featured ? "text-[1.75rem] text-chalk md:text-5xl" : "text-2xl md:text-4xl"}`} data-id="element-235" data-mp="3uybm2a44z7uz">
                  {p.price}
                </span>
                {p.featured && <span className="mt-1.5 inline-block rounded-md bg-chalk px-1.5 py-0.5 text-[10px] font-bold text-white md:text-xs" data-id="element-236" data-mp="1e9k69gl775an">{p.savings}</span>}
              </span>
            </button>;
      })}
      </div>

      <div className="mt-3 md:mt-5" data-id="element-237" data-mp="220oeugowdpyd">
        <CtaButton href={selected.checkoutUrl} variant="primary" full data-id="element-238" data-mp="21zmu1ki2xp3g">
          <motion.span key={selected.id} initial={{
          opacity: 0,
          y: 4
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.16,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-239" data-mp="1xyks2vws2yxs">
            {selected.cta} · {selected.price}
          </motion.span>
        </CtaButton>
        <p className="mt-2 text-center text-xs text-muted md:text-sm" data-id="element-240" data-mp="hm5q7kjghad5">
          {selected.featured ? offer.featuredNote : "Podés sumar los 2 Premium eligiendo el Pack Completo"}
        </p>
      </div>

      <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted md:mt-4 md:gap-x-6 md:text-sm" data-id="element-241" data-mp="e2nfeh6pww36">
        {offer.trust.map((t, i) => {
        const Icon = trustIcons[i];
        return <li key={t} className="flex items-center gap-1" data-id="element-242" data-mp="nzjoop4fxm8s" data-mpi={i}>
              <Icon className="h-3.5 w-3.5 text-chalk" aria-hidden="true" data-id="element-243" data-mp="szo92q8gz14a" />
              {t}
            </li>;
      })}
      </ul>
    </div>;
}